import axios from "axios"
import store from "@/store"
import router from "@/router"
// import { setupCache } from "axios-cache-interceptor"

function readCookie(name) {
  const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"))
  return match ? decodeURIComponent(match[3]) : null
}

// helper method that converts django rest error response to a a human readable string
export function getErrorMessage(er) {
  let error = er.response.data
  this.server_errors = []
  if (error["code"] == "BAD_REQUEST") {
    if (Object.keys(error["errors"]).length > 0) {
      Object.keys(error["errors"]).forEach((key) => {
        this.server_errors.push(...error["errors"][key])
      })
    }
  } else if (error?.errors?.detail) {
    this.server_errors.push(error.errors.detail)
  }
  return this.server_errors.join("\n")
}

class ApiService {
  static instance
  static pendingRequests = new Map()

  constructor() {
    if (ApiService.instance) {
      return ApiService.instance
    }

    let BASE_API_URL = import.meta.env.VITE_BASE_API_URL || "https://api.revsetter.com"
    console.debug(`API Service for ${BASE_API_URL}`)
    const session = axios.create({
      baseURL: BASE_API_URL,
      headers: {
        "X-CSRFToken": readCookie("csrftoken"),
        "X-Timezone-Offset": new Date().getTimezoneOffset(),
        "X-Request-Start": Date.now(),
        "Content-type": "application/json"
      }
    })

    session.interceptors.request.use(this.handleRequest)
    session.interceptors.response.use(this.handleResponse)

    ApiService.instance = session
    // ApiService.instance = setupCache(session, {
    //   ttl: 10,
    //   debug: console.debug,
    //   methods: ["GET", "PATCH"]
    // })
  }

  handleRequest(config) {
    const token = store.state.auth?.token || null
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }

    const routerName = router.currentRoute.value.name
    const fullPath = router.currentRoute.value.fullPath
    const invalidateCache = router.currentRoute.value.query.invalidate_cache
    config.headers["X-Origin-Page-Name"] = routerName
    config.headers["X-Origin-Page-Path"] = fullPath
    config.headers["X-Origin-Invalidate-Cache"] = invalidateCache

    if (routerName === "WorkspaceItem" && store.state.ui.currentWorkspace) {
      config.headers["X-Origin-Layout-Owner-Id"] = store.state.ui.currentWorkspace.created_by
      config.headers["X-Origin-Workspace-Id"] = store.state.ui.currentWorkspace.id
    } else {
      config.headers["X-Origin-Layout-Owner-Id"] = store.state.ui_options?.current_layout_owner_id
    }

    if (store.state.organization?.id) {
      config.headers["X-Origin-Org-Id"] = store.state.organization.id
    }

    return config
  }
  // handle response and add error message if needed
  handleResponse(response) {
    if (response.status != 200 && response.status != 201 && response.status != 204 && response.status != 500) {
      response.data.message = getErrorMessage(response)
      response.message = response.data.message
    }
    return response
  }

  static getInstance() {
    if (!ApiService.instance) {
      new ApiService()
    }
    return ApiService.instance
  }
}

export default ApiService.getInstance()
